import React from "react";

import ContentCard from "@JohnLewisPartnership/jlfs-ui-library/dist/components/contentCardSection/contentCard/contentCard";

import {
  formatOpeningHours,
  formatTimeRange,
  days,
} from "../specificStoreUtils/specificStoreUtils";
import { TFormatStore } from "../../wrappers/StoreLocatorWrapper/StoreLocatorUtils/StoreLocatorUtils";
import styles from "./StoreDetails.module.scss";

export type TStoreDetails = {
  storeDetails: TFormatStore;
};

const StoreDetails = ({ storeDetails }: TStoreDetails) => {
  const CARD_TITLES = {
    address: "Address",
    openingTimes: "Opening times",
    services: "Travel Money services",
  };

  const openingTimesData = Object.fromEntries(
    days.map((day) => [day, storeDetails[day]])
  );

  const openingTimes = formatOpeningHours(
    // @ts-ignore
    openingTimesData,
    !!storeDetails.bankHoliday
  );

  const eurosAndUsDollarsToGo =
    storeDetails.isEurosAndUsDollarsToGo &&
    storeDetails.division === "Waitrose";

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Store Details</div>
      <div className={styles.cards}>
        <ContentCard
          icon={<img src="/icons/address-pin.svg" alt="store address" />}
          iconAlignment="Left"
          title={CARD_TITLES.address}
          content={
            <>
              <p>
                {storeDetails.division}
                {storeDetails.floor}
              </p>
              <p>{storeDetails.branchName}</p>
              <p>
                {storeDetails.fullAddress}, {storeDetails.postcode}
              </p>
            </>
          }
          backgroundColour="Citrine"
          image={null}
        />
        <ContentCard
          icon={<img src="/icons/opening-times.svg" alt="opening times" />}
          iconAlignment="Left"
          title={CARD_TITLES.openingTimes}
          content={
            <>
              {openingTimes.map((row, index) => (
                <p key={row}>
                  {row}
                  {openingTimes.length - 1 === index &&
                  storeDetails.browsingHours
                    ? ` (Browsing only ${formatTimeRange(
                        storeDetails.browsingHours
                      )})`
                    : ""}
                </p>
              ))}
              {storeDetails.bankHoliday && (
                <>
                  <br />
                  <p>
                    *Bank Holiday Hours:{" "}
                    {formatTimeRange(storeDetails.bankHoliday)}
                  </p>
                </>
              )}
            </>
          }
          backgroundColour="Citrine"
          image={null}
        />
        {(storeDetails.isBureau ||
          storeDetails.isClickAndCollect ||
          eurosAndUsDollarsToGo) && (
          <ContentCard
            icon={<img src="/icons/services-icon.svg" alt="services details" />}
            iconAlignment="Left"
            title={CARD_TITLES.services}
            content={
              <ul>
                {storeDetails.isBureau && (
                  <>
                    <li>Buying currency</li>
                  </>
                )}
                {storeDetails.isClickAndCollect && <li>Click & collect</li>}
                {eurosAndUsDollarsToGo && <li>Euros and US Dollars to go</li>}
              </ul>
            }
            backgroundColour="Citrine"
            image={null}
          />
        )}
      </div>
    </div>
  );
};

export default StoreDetails;
